/**
 * Created by Ning Jiang on 2023-09-13.
 */

import {DCRoadSymbol} from "./DCRoadSymbol";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {gsap, TimelineLite} from "gsap";

export class WildSymbol extends DCRoadSymbol {

    constructor(reelId:number, symId:number) {
        super("W", reelId, symId);

    }

    protected initSpine():void {
        if(!this._spine) {
            this._spine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset(this.symbolName[0]));
            this._spine.autoUpdate = true;
            // this._animationContainer.addChild(this._spine);
        }
    }

    public playLanding(init:boolean):TimelineLite {
        const tl = gsap.timeline();
        // tl.add(super.playLanding(init));
        tl.add(() => {
            this._animationContainer.addChild(this._spine);
            this._spine.state.setAnimation(0, "appear", false);
        });
        tl.add(() => {
            this._spine.state.setAnimation(1, "fx", true);
        }, this._spine.spineData.findAnimation("appear").duration);
        return tl;
    }
}